export const environment = {
  production: false,
  env: 'Staging'

};
